import { Skeleton } from '@mui/material';

/**
 * The list's shape while it loads.
 *
 * Mirrors the real layout — a hero, then grouped cards — so the screen does not
 * reflow when the data lands. A centred spinner would tell the director nothing
 * about what is coming and would move everything the moment it did.
 */
export const OutstandingSkeleton = () => (
  <div
    className="flex flex-col gap-4"
    role="status"
    aria-label="Loading your outstanding items"
  >
    <Skeleton variant="rounded" height={168} className="rounded-3xl" />

    {[0, 1].map((group) => (
      <div
        key={group}
        className="overflow-hidden rounded-3xl border border-divider bg-surface shadow-card"
      >
        <div className="bg-surface-subtle px-4 py-3.5">
          <Skeleton variant="text" width="55%" height={20} />
          <Skeleton variant="text" width="30%" height={16} />
        </div>

        {[0, 1].map((row) => (
          <div key={row} className="flex items-start gap-3 border-t border-divider px-4 py-3.5">
            <Skeleton variant="rounded" width={36} height={36} className="rounded-xl" />
            <div className="flex-1">
              <Skeleton variant="text" width="65%" height={20} />
              <Skeleton variant="text" width="40%" height={16} />
            </div>
          </div>
        ))}
      </div>
    ))}
  </div>
);
